import moment from "moment-timezone";
import { covertTimeSatmp } from "../services/trackerServices.js";
import { validateTimeFormat } from "./cardBodyUiHelpers.js";

/**
 * Time Display Helpers for CardBody Component
 * Contains functions for displaying and formatting time
 */

/**
 * Show and edit time based on duration input
 * @param {Object} params - Parameters for time display
 * @returns {void}
 */
export const timeShowEdit = ({
  timeSec,
  dateEdit,
  startTimeEdit,
  setUDuration,
  setUFormatedTime,
  setUFormatedTimeError,
  setEndTimeEdit,
  setUStartTimeError,
  setUEndTimeError,
}) => {
  if (validateTimeFormat(timeSec)) {
    const timeString = timeSec;
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const totalSeconds =
      parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
    // Do the arithmetic in the app timezone. This previously parsed a naive
    // string with `new Date(...)` and formatted with toLocaleTimeString(),
    // both of which use the BROWSER's zone — so the end time shown depended
    // on where the viewer sat rather than on the entry's own timezone.
    const zone = global.config.getTimeZone();
    const startWallClock = covertTimeSatmp(
      dateEdit,
      startTimeEdit && startTimeEdit.trim(),
      zone
    );

    setUDuration(parseInt(totalSeconds));

    const start = moment.tz(startWallClock, "YYYY-MM-DD HH:mm:ss", zone);
    const formattedTime = start.isValid()
      ? start.clone().add(totalSeconds, "seconds").format("hh:mm A")
      : null;

    setUFormatedTimeError(false);
    setEndTimeEdit(formattedTime);
    setUFormatedTimeError(false);
    setUStartTimeError(false);
    setUEndTimeError(false);
  } else {
    setUFormatedTimeError(true);
  }
  setUFormatedTime(timeSec);
};
